import {Component, OnInit} from '@angular/core';
import {MenuServiceInt} from '@core/_services/menu.serviceint';
import {MessagesService} from '@core/_services/messages.service';
import {ConfirmationService} from 'primeng/api';
import {SelectItem} from 'primeng/api';
import {dateFormat} from '@core/_utils/date.utils';
import {CommonService} from '@service/common.service';
import {LayoutService} from '../../layout/service/app.layout.service';
import {TranslateService} from '@ngx-translate/core';
import {lastValueFrom} from 'rxjs';
import {ApiV6Service} from '@service/apiv6.service';
import {AuthService} from '@auth/auth.service';
import {ItemConfirmComponent} from '../_components/item-confirm/item-confirm.component';
import {findItem, truncString} from '@core/_utils/tools.utils';

@Component({
    selector: 'page-mail',
    templateUrl: './page-mail.component.html',
    styleUrls: ['./page-mail.component.scss'],
})
export class PageMailComponent implements OnInit {
    public selectedRows: any[];
    public batchList = [];
    public isDesktop: boolean = false;
    public error = false;
    public errorMessage = '';
    public errorLoaderDialog = false;
    public typeList: SelectItem[];
    public stateList: SelectItem[];
    public listColumns = [];
    public isAdmin = false;
    public itemConfirm: ItemConfirmComponent;
    public disabledDel = true;
    public selectedCount = 0;
    public displayModal: boolean = false;
    public messageContent = {
        id: '',
        sender: '',
        subject: '',
        recipients: '',
        send_at: '',
        message: ''
    };

    // Etat
    // 0 : Envoyé
    // 1 : En cours
    // 2 : Erreur

    constructor(
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private main: LayoutService,
        private auth: AuthService,
        private translate: TranslateService,
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.isAdmin = this.auth.isAdmin();
        this.selectedRows = new Array();
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.stateList = [
            {label: this.translate.instant('All'), value: null},
            {label: this.translate.instant('Mail_Type_0'), value: 'send'},
            {label: this.translate.instant('Mail_Type_1'), value: 'queued'},
            {label: this.translate.instant('Mail_Type_2'), value: 'error'}
        ];

        this.listColumns = [
            {header: this.translate.instant('Mail_DtCreate'), field: 'created_at', type: 'DateTime', sort: 'created_at'},
            {header: this.translate.instant('Mail_Emit'), field: 'sender', type: 'String', sort: 'sender'},
            {header: this.translate.instant('Mail_Dest'), field: 'recipients', type: 'String', sort: 'recipients'},
            {header: this.translate.instant('Mail_Subject'), field: 'subject', type: 'String', sort: 'subject'},
            {header: this.translate.instant('Mail_DtSend'), field: 'sent_at', type: 'DateTime', sort: 'sent_at'},
            {header: this.translate.instant('Mail_State'), field: 'status', type: 'string', sort: 'status'}
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    public ngOnDestroy() {
    }

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getmaillist', ''));
            this.setFormatedData(wRes);
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
    }

    private setFormatedData(aRes) {
        this.disabledDel = true;
        this.batchList = aRes.data.data.map((item) => {
            item.created_at = item.created_at + '|' + dateFormat(item.created_at, 'dd/MM/yyyy HH:mm:ss');
            if (item.sent_at !== null) {
                item.sent_at = item.sent_at + '|' + dateFormat(item.sent_at, 'dd/MM/yyyy HH:mm:ss');
            }
            return item;
        });
    }

    public onDetail(event, rowData) {
        this.messageContent = rowData;
        this.displayModal = true;
    }

    public async onSend(event, rowData) {
        let wRes;
        let wIndex = -1;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('resendmail', {'id': rowData.id}));
            wIndex = findItem(this.batchList, rowData.id, 'id');
            if (wIndex !== -1) {            
                this.batchList[wIndex]['sent_at'] = wRes.data.sent_at  + '|' + dateFormat(wRes.data.sent_at, 'dd/MM/yyyy HH:mm:ss');
                this.batchList[wIndex]['status'] = wRes.data.status;
            }
            this._messageService.addInfo(this.translate.instant('Send_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Send_KO'));
        } 
    }

    public clickDelMail() {
        if (this.selectedRows.length !== 0) {
            this.itemConfirm.confirmAction(
                'delete',
                this.translate.instant('Confirm_DelMail'),
                () => {
                    this.delete();
                }
            );
        }
    }

    public async delete() {
        let wList = '';
        let wParams: {};
        this.selectedRows.forEach((item) => {
            if (item.status !== 'queued') {
                wList = wList + item.id + ',';
            }
        });
        wList = truncString(wList, 1);
        wParams = {
            list: wList
        };
        try {
            await lastValueFrom(this.api.execUrlAction('deletemail',wParams));
            this._messageService.addSuccess(this.translate.instant('Update_OK'));
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
        this.selectedRows = [];
        await this.findAll();
    }

    public clickcolck(event) {
        event.stopPropagation();
    }

    public getRecipients(recipients: string): string {
        if (recipients) {
            const recipientsArray = JSON.parse(recipients);
            return recipientsArray.join(", ");
        }
    }
}
